import { QuestionRadioButtonsField, QuestionTextField, QuestionStockMarketAutocompleteField } from 'components/Questionnaires/fields';
import { requiredValidator } from 'components/Questionnaires/validators';

export function publiclyTradedNffeBlock({ isVisible = true }) {
  return {
    id: 'publiclyTradedNffe',
    title: 'questionnaire.ch4.publiclyTradedNffe',
    component: undefined,
    info: {
      instructions: 'questionnaire.ch4.publiclyTradedNffe.info',
    },
    visible: isVisible,
    questions: [
      {
        id: 'certification',
        component: QuestionRadioButtonsField,
        componentProps: {
          items: 'questionnaire.ch4.publiclyTradedNffe.certification.items',
          inputName: 'regularlyTraded'
        },
        visible: true,
        label: 'questionnaire.ch4.publiclyTradedNffe.certification.label',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch4.publiclyTradedNffe.certification.errorMessage' }
          ]
        }
      },
      {
        id: 'entityName',
        label: 'questionnaire.ch4.publiclyTradedNffe.entityName.label',
        component: QuestionTextField,
        visible: bAnswers => bAnswers?.certification === '2',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch4.publiclyTradedNffe.entityName.errorMessage' }
          ]
        }
      },
      {
        id: 'securityMarket',
        label: 'questionnaire.ch4.publiclyTradedNffe.securityMarket.label',
        component: QuestionStockMarketAutocompleteField,
        placeholder: 'questionnaire.ch4.publiclyTradedNffe.securityMarket.placeholder',
        visible: bAnswers => bAnswers?.certification,
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch4.publiclyTradedNffe.securityMarket.errorMessage' }
          ]
        }
      },
    ]
  };
}

export default publiclyTradedNffeBlock;
